// src/lib/stock-api.js — client de l'endpoint /api/stock (Lot 1).
//
// Lot 1 : le domaine STOCK est passé du KV fbz8-* aux tables V2, derrière un
// endpoint serveur role-aware. Chaque mutation renvoie le snapshot complet
// { stockCentral, depots, achats } recalculé serveur (cascade incluse) → le
// front applique ce snapshot sans 2e aller-retour. Les erreurs serveur sont
// remontées telles quelles (message FR) pour affichage en toast.

import { supabase } from '../supabase'
import { lireJsonOuRefuser } from './reponse-json'

/** Lecture — montrée en bandeau (cf. src/lib/reponse-json.js). */
export const MESSAGE_STOCK_ILLISIBLE =
  "Je n'ai pas pu lire ton stock : ce que le serveur a renvoyé n'en était " +
  "pas un. Les quantités peuvent s'afficher vides ou incomplètes — rien " +
  "n'est perdu, recharge la page."

/** Écriture — on ne peut pas dire si c'est passé. */
export const MESSAGE_STOCK_ECRITURE_ILLISIBLE =
  "Je n'ai pas pu lire la réponse du serveur : je ne sais pas si " +
  "l'opération est passée. Ne réessaie pas à l'aveugle — recharge la page " +
  "pour voir l'état réel du stock."

async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession()
  const token = session?.access_token
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }
}

// Le verdict « ce n'est pas du JSON » vit dans src/lib/reponse-json.js —
// quatre recopies de cette fonction laissaient passer une page HTML en 200
// pour un blob vide, et vidaient les écrans sans un mot.
async function parseOrThrow(res, fallback, messageIllisible) {
  return lireJsonOuRefuser(res, fallback, messageIllisible)
}

// GET — snapshot : entier pour l'admin ; vue cloisonnée par le serveur pour
// l'orchestrateur (ses logements, sans prix ni achats). Rôle ménage : 403.
export async function fetchStock() {
  const res = await fetch('/api/stock', { headers: await authHeaders() })
  return parseOrThrow(res, 'Lecture stock échouée', MESSAGE_STOCK_ILLISIBLE)
}

async function postStock(action, body) {
  const res = await fetch(`/api/stock?action=${encodeURIComponent(action)}`, {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify(body || {}),
  })
  return parseOrThrow(res, 'Opération stock échouée', MESSAGE_STOCK_ECRITURE_ILLISIBLE)
}

export const stockApi = {
  fetchStock,
  depotUpsert: (depot) => postStock('depot_upsert', { depot }),
  depotDelete: (id) => postStock('depot_delete', { id }),
  achatCreate: (achat) => postStock('achat_create', { achat }),
  achatDelete: (id) => postStock('achat_delete', { id }),
  stockSet: (csId, patch) => postStock('stock_set', { csId, ...patch }),
}
